<template>
  <div>
  	<div v-if="!showMoreRoomOnly" class="position-relative" style="z-index: 1042">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0px;top: 0">
          <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="pb-2 bg-white box-shadow-main scroll-hide-mobile" style="overflow-y: scroll;height: 100vh;min-height: 100%">
                  <div class="px-4 pt-3 mb-2 pb-1 sticky" style="top: 0">
                    <img src="../../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="close()">
                    <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">{{$t('hotel.more-information')}}</p>
                  </div>
                  <div class="scroll-hide-mobile" style="height: 90vh;overflow-y: scroll;">
                    <div class="container px-4">
                      <div class="mt-3">
                        <p class="mb-2 body-2-2 font-bold text-18 d-block">{{data.name}}</p>

                        <!-- DESCRIPTION -->
                        <template v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                          <p class="pt-4 mb-1 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
                          <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-3-3 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
                          <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                          <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
                        </template>

                        <!-- CANCELLATION POLICY -->
                        <template v-if="data.cancellation_policy != null">
                          <div class="d-block mb-3 mt-4">
                            <p class="mb-1 body-3-3 text-16 font-bold">{{data.cancellation_policy.title}}</p>
                            <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.cancellation_policy.description"></p>
                          </div>
                        </template>

                        <!-- TERMS & CONDITIONS -->
                        <template v-if="$isNotEmpty(data.term_and_condition_room_rate) || $isNotEmpty(data.term_and_condition_promotion)">
                          <div class="d-block mb-3 mt-4">
                            <div class="mb-3" v-if="$isNotEmpty(data.term_and_condition_room_rate)">
                              <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_room_rate.title}}</p>
                              <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_room_rate.description"></p>
                            </div>
                            <div v-if="$isNotEmpty(data.term_and_condition_promotion)">
                              <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_promotion.title}}</p>
                              <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_promotion.description"></p>
                            </div>
                          </div>
                        </template>

                        <!-- RATE INCLUSIONS -->
                        <template v-if="data.rate.inclusion.length > 0">
                          <p class="pt-3 mb-1 body-3-3 text-16 font-bold">{{$t('hotel.room-type.include-in-rate')}}</p>
                          <div class="height-auto">
                            <ul  class="pl-3">
                              <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                                <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                                <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                              </li>
                            </ul>
                          </div>
                        </template>

                        <!-- BREAKDOWN RATE -->
                        <template v-if="roomAvbl(data.room_type.id,data.id) > 0 && !data.rate.is_package">
                          <p class="mt-4 mb-2 body-2-2 text-15 font-bold">{{$t('hotel.rate-breakdown.title')}}</p>
                          <template v-for="(rate,index) in data.dates">
    	                      <div class="row slim-grid-row">
                              
    	                        <div @click="toggleRateDetail(rate.date)" class="col-6">
    	                          <p class="mb-0" :class="{'body-2-4':rate.date == rate_detail, 'body-2-2': rate.date != rate_detail}">{{customFormatDateTime(rate.date)}}</p>
                                <!-- PROMO COMBINE -->
                                <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != '' && rate.date != rate_detail && rate.price >= rate.final_price" class="text-green mb-0 body-3-3-2 font-regular text-truncate">{{promotionCounter(rate.promo_combine)}}</p>
    	                        </div>
    	                        <div @click="toggleRateDetail(rate.date)" class="col-6 text-right">
                                <!-- PROMO COMBINE -->
                                <p v-if="rate.date == rate_detail && rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="text-green mb-0 body-2-2 font-regular text-truncate">{{promotionCounter(rate.promo_combine)}}</p>
                                <div class="w-100 no-ws" v-else>
                                  <!-- PROMO COMBINATION -->
                                  <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="mb-0 d-inline-block align-middle mr-2 body-3-3-2 text-orange">{{ +parseFloat(100-$getPercentage(rate.price+rate.extra_guest_price, printTotalPriceWithTax(rate.final_price, rate.taxes),2)).toFixed(2) }}%</p>
      	                          <p class="mb-0 font-semibold" :class="{'text-line-through body-3-3-1 d-inline-block align-middle': rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != '', 'body-2-2' : rate.promotion_price >= 0}">
      	                          	<template v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''">
      	                          		{{formatCurrency(rate.price+rate.extra_guest_price)}}
      	                          	</template>
      	                          	<template v-else>
      	                          		{{formatCurrency(printTotalPriceWithTax(rate.final_price, rate.taxes))}}
      	                          	</template>
      	                          </p>
                                  <!-- PROMO COMBINATION -->
      	                          <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="mb-0 body-2-1 font-regular">{{ $formatCurrency(printTotalPriceWithTax(rate.final_price, rate.taxes))}}</p>
                                  <!-- <p v-if="rate.promotion_price < 0 && rate.promotion.promotion_type != 'REMAINING_OCCUPANCY'" class="text-orange mb-0 body-2-2 font-regular">{{formatCurrency(rate.final_price)}}</p> -->
                                </div>
    	                        </div>
                              
                              <div v-if="rate.date != rate_detail" class="col-12" @click="toggleRateDetail(rate.date)">
                                <p class="mb-0 body-3-3-2 font-regular text-center">{{$t('hotel.room-type.detail-rates')}}</p>
                              </div>
    	                      </div>
                            <div class="w-100" @click="toggleRateDetail()" v-if="rate.date == rate_detail">
                              <div class="row slim-grid-row mb-1 mt-2">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{total_guest_included}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate.price+rate.promotion_price)}}</p>
                                </div>
                              </div>
                              <!-- extra adult -->
                              <div class="row slim-grid-row mb-1" v-if="rate.extra_guest.adult.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate.extra_guest.adult.qty}}x {{$t('hotel.rate-breakdown.extra-adults')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate.extra_guest.adult.total)}}</p>
                                </div>
                              </div>
                              <!-- extra child -->
                              <div class="row slim-grid-row" v-if="rate.extra_guest.child.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate.extra_guest.child.qty}}x {{$t('hotel.rate-breakdown.extra-childs')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate.extra_guest.child.total)}}</p>
                                </div>
                              </div>
                              <!-- extra infant -->
                              <div class="row slim-grid-row mb-1" v-if="rate.extra_guest.infant.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate.extra_guest.infant.qty}}x {{$t('hotel.rate-breakdown.extra-infants')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate.extra_guest.infant.total)}}</p>
                                </div>
                              </div>
                              <!-- green tax -->
                              <div class="row slim-grid-row" v-if="getMerchant().search_room_is_show_tax_fee_note && rate.taxes > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">Green Tax</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate.taxes)}}</p>
                                </div>
                              </div>
                              <div class="row slim-grid-row mb-1">
                                <div class="col-6">
                                  <p class="mb-0 body-2-4 mt-1">{{$t('hotel.total')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="d-table ml-auto mt-1 mb-0 body-2-2 font-regular text-right text-orange border-top">{{formatCurrency(printTotalPriceWithTax(rate.final_price, rate.taxes))}}</p>
                                </div>
                              </div>
                            </div>
    	                      <div v-if="(index+1) < data.dates.length" class="border-bottom-dashed w-100 my-2"></div>
    	                      <div v-else class="border-bottom-2 w-100 mt-3 mb-2"></div>
                          </template>
                        </template>
                      </div>
                      <template v-if="roomAvbl(data.room_type.id,data.id) > 0">
                        <div class="row slim-grid-row" :class="{'mt-2': data.rate.is_package}">
                          <div class="col-6">
                            <p class="mb-0 body-2-2 font-bold">{{$t('hotel.rate-breakdown.full-rates')}} : </p>  
                          </div>
                          <div class="col-6 text-right">
                            <p class="mb-0 body-2-2 text-16 font-bold">{{formatCurrency(total_rates(data.dates))}}</p>
                          </div>
                        </div>
                      </template>
                    </div>
                    <template v-if="roomAvbl(data.room_type.id,data.id) > 0">
                      <div class="container position-relative px-4 mt-4 mb-3">
                        <button type="button" id="rate_breakdown" class="button-secondary w-100" @click="is_popup_avlb = true">{{$t('hotel.book-now')}}</button>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="is_popup_avlb" class="position-relative" style="z-index: 1043">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="rounded-top-6">
                    <div class="w-100 py-2 px-4" style="height: 100vh;background-color: #00000066">
                      <div class="bg-white border mt-2 rounded-4 box-shadow-bold position-relative" style="top: 100px;">
                        <div class="m-3">
                          <img src="../../../../assets/img/icon/close.png" class="d-inline-block cursor-pointer align-top position-relative" width="15" style="top: 5px;" @click="toggleRoomAvlb(false,true)">
                          <p class="mb-0 body-2-2 d-inline-block w-80 text-16 ml-2 font-semibold">{{$t('hotel.more-rooms-desc')}}</p>
                        </div>
                        <div v-show="!is_popup_avlb_form">
                          <template v-for="n in roomAvbl(data.room_type.id,data.id,true)">
                            <p 
                              v-if="n < 6"
                              :class="{'border-top': n == 0, 'text-green': selected_room_rate == n}" 
                              class="mb-0 border-bottom body-2-2 text-14 font-bold py-12px cursor-pointer text-center hover position-relative" 
                              @click="addRoomRate(n,data)">
                              {{n}} {{$t('hotel.rooms')}}
                              <i v-if="selected_room_rate == n" style="left:20px;top:16px;" class="text-green simple-icon-check position-absolute"></i>
                            </p>

                            <p v-else class="mb-0 border-bottom body-2-2 text-14 font-bold py-12px cursor-pointer text-center hover" @click="toggleRoomAvlb()">{{$t('hotel.more-rooms')}} <span v-if="selected_room_rate > 5">(Current {{selected_room_rate}})</span></p>
                          </template>
                        </div>

                        <div v-show="is_popup_avlb_form">
                          <div class="px-3 pb-3">
                            <div class="mt-2 mb-3 text-center">
                              <p class="body-3-3 mb-1">{{roomAvbl(data.room_type.id,data.id)}} {{$t('hotel.rooms-left')}}</p>
                              <input 
                                @keypress="inputCustomOnly" 
                                type="text" 
                                ref="inputmore" 
                                v-model="more_room" 
                                class="form-control mb-2 text-center font-bold"
                                :class="{'border-danger': is_room_avlb_not_valid}">
                                <p v-if="is_room_avlb_not_valid" class="body-3-3 mb-0 text-danger">{{$t('hotel.more-rooms-warning')}}</p>
                            </div>
                            <div class="row slim-grid-row">
                              <div class="col-6">
                                <button class="button-black w-100" @click="toggleRoomAvlb(true)">{{$t('general.cancel')}}</button>
                              </div>
                              <div class="col-6">
                                <button :disabled="is_room_avlb_not_valid" class="button-primary w-100" @click="addRoomRate(more_room,data)">{{$t('hotel.book-now')}}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
	import {formatCurrency,formatDate,customFormatDateTime,inputCustomOnly,roomAvbl} from '@/utils/index.js'
	import VueGallerySlideshow from 'vue-gallery-slideshow';
	import moment from 'moment'
  import {mapGetters,mapMutations} from 'vuex'
	export default{
		props: {
			data:{
				type: Object,
				default: () => {}
			},
      more_room_form:{
        type: Boolean,
        default: false
      },
      show_img: {
        type: Boolean,
        default: false
      },
      showMoreRoomOnly:{
        type: Boolean,
        default: false
      }
		},
		components:{
			VueGallerySlideshow
		},
		data(){
			return{
				images: [],
				booking_detail_rate: false,
				index: null,
        rate_detail: '',
        is_popup_avlb: false,
        is_popup_avlb_form: false,
        more_room: 5,
        more_inclusions: true
			}
		},
    computed:{
      total_guest_included(){
        let total = this.getBeFilter().guest.adult+this.getBeFilter().guest.child+this.getBeFilter().guest.infant
        if(total  <= this.data.rate.guest_included){
          return total
        }else{
          return this.data.rate.guest_included
        }
      },
      selected_room_rate(){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == this.data.id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }
        return display
      },
      is_room_avlb_not_valid(){
        let display = false
        if(this.more_room == '' || this.more_room == 0 || this.more_room > this.roomAvbl(this.data.room_type.id,this.data.id)){
          display = true
        }
        return display
      }
    },
		mounted(){
      if(this.more_room_form){
        this.is_popup_avlb = true
        this.toggleRoomAvlb()
      }
			for(let i = 0; i < this.data.room_type.image.length; i++){
				this.images.push({
					url: this.data.room_type.image[i].image_url,
					alt: this.data.room_type.image[i].title
				})
			}
      
      this.$sendEventMetaConversionsAPI('ViewContent', {
        id: this.data.id_ori,
        name: this.data.name,
        dates: this.data.dates
      }, 'Room Rate');
		},
		methods:{
      ...mapGetters(['getBeSortBy','getBeFilter','getBeCartRoom', 'getMerchant']),
      ...mapMutations(['BeManipulateRoomRate','changeBeRoomAvbl', 'beRemoveRoomRate']),
      printTotalPriceWithTax(price, taxes){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
        return showTax ? price : price - taxes
      },
      inputCustomOnly($event){
        inputCustomOnly('number',$event)
      },
      roomAvbl(room_type_id,room_rate_id,limit=false){
        return roomAvbl(room_type_id,room_rate_id,limit)
      },
      customFormatDateTime(date){
      	return customFormatDateTime(date,'YYYY-MM-DD','DD MMM YYYY')
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      // PROMO COMBINATION
      promotionCounter(data){
        let promotion = ''
        if(data != null){
          for(let i = data.promotion_list.length-1; i >= 0; i--){
            let item = data.promotion_list[i]
            let validate = {
              price: item.promotion_price < 0,
              not_ro: item.promotion_type != 'REMAINING_OCCUPANCY',
              is_apply: item.is_apply
            }
            if(validate.price && validate.not_ro && validate.is_apply){
              if(promotion == ''){
                promotion += item.name
              }else{
                promotion += `, ${item.name}`
              }
            }
          }
        }
        return promotion
      },
      total_rates(data){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
      	let display = 0
				for(let i = 0 ; i < data.length; i++){
					display += data[i].final_price
          if(!showTax) display -= data[i].taxes
				}
				return display
      },
      close(){
      	this.$emit("close")
      },
      toggleRateDetail(date = ''){
        // this.rate_detail = ((this.rate_detail != '' && ) || (this.rate_detail == '' && date == '')) ? '' : date
        if(this.rate_detail == ''){
          this.rate_detail = date != '' ? date : ''
        }else{
          if(date == this.rate_detail){
            this.rate_detail = ''
          }else{
            this.rate_detail = date
          }
        }
      },
      roomVisible(avlb){
        return (avlb < 5) ? avlb : 6
      },
      toggleRoomAvlb(cancel=false,close=false){
        this.more_room = this.selected_room_rate
        if(this.showMoreRoomOnly && (cancel || close)){
          this.close()
          return;
        }
        if(cancel){
          this.is_popup_avlb_form = false
        }else{
          if(close){
            this.is_popup_avlb_form = false
            this.is_popup_avlb = false
          }else{
            this.is_popup_avlb_form = true
            let self = this
            this.$nextTick(() => {
              self.$refs.inputmore.focus()
              self.$refs.inputmore.select()
            })
          }
        }
      },
      updateRoomTypeAvailability(qty, currentRoomRate, action){
        const { 
          id: rr_id, 
          room_type: { id, is_virtual, availability_affected } 
        } = currentRoomRate
        let availabilityParams = { 
          id, 
          rr_id, 
          is_virtual, 
          availability_affected, 
          action,
          qty 
        }
        this.changeBeRoomAvbl(availabilityParams);
      },
      generateRemainingGuestFilter(){
        const GUEST_TYPE = ['adult','child','infant'];

        let remainingGuestFilter = this.$deepCopy(this.getBeFilter().guest)
        this.getBeCartRoom().forEach(savedRoomRate => {
          savedRoomRate.guest.forEach(savedRoomRateGuest => {
            const { included, extra } = savedRoomRateGuest;
            
            const savedGuestsPerRoomRate = GUEST_TYPE.reduce((acc, key) => {
              acc[key] = included[key] + extra[key];
              return acc;
            }, {});

            GUEST_TYPE.forEach(guest => {
              if(remainingGuestFilter[guest] > 0){
                remainingGuestFilter[guest] -= savedGuestsPerRoomRate[guest]
              } else {
                remainingGuestFilter[guest] = 0
              } 
            })
          });
        })
        return remainingGuestFilter
      },
      includeGuestParamsIfZeroTotal(guest_included, roomConfig){
        let guestIncluded = { adult: 0, child: 0, infant: 0 }
        const currentGuestFilter = this.$deepCopy(this.getBeFilter().guest)

        const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = roomConfig
        
        if(use_max_guest_by_pax){
          guestIncluded.adult = Math.min(guest_included, max_guest_adult);

          let remainingPax = guest_included - guestIncluded.adult;

          if (currentGuestFilter.child > 0 && remainingPax > 0) {
            guestIncluded.child = Math.min(remainingPax, max_guest_children);
            remainingPax -= guestIncluded.child;
          }

          if (currentGuestFilter.infant > 0 && remainingPax > 0) {
            guestIncluded.infant = Math.min(remainingPax, max_guest_infant);
          }
        }else{
          if(currentGuestFilter.adult > guest_included){
            guestIncluded = { adult: guest_included, child: 0, infant: 0 }
          }else{
            guestIncluded.adult = currentGuestFilter.adult
            const remainingGuestIncludedAfterAdult = guest_included - currentGuestFilter.adult
        
            if(remainingGuestIncludedAfterAdult > 0){
              
              if(currentGuestFilter.child > remainingGuestIncludedAfterAdult){
                guestIncluded.child = remainingGuestIncludedAfterAdult
              }else{
                guestIncluded.child = currentGuestFilter.child
                const { adult, child } = guestIncluded
                const remainingGuestIncludedAfterAdultChild = guest_included - (adult + child)
                const isInfantExist = currentGuestFilter.infant > remainingGuestIncludedAfterAdultChild
                if(remainingGuestIncludedAfterAdultChild > 0 && isInfantExist){
                  guestIncluded.infant = remainingGuestIncludedAfterAdultChild
                }
              }
            }
          }
        }
        return guestIncluded;
      },
      allocateGuestPerRoom(guestParamsIncluded, remainingGuestFilter, guest_included){
        let includedGuest = guestParamsIncluded
        let remainingGuest = remainingGuestFilter
        
        const GUEST_TYPE = ['adult','child','infant'];
        GUEST_TYPE.forEach(guest => {
          let totalGuestIncludedPerRoom = Object.values(includedGuest).reduce((sum, value) => sum + value, 0);
          if(remainingGuest[guest] > 0 && totalGuestIncludedPerRoom < guest_included){
            let remainingPaxPerRoom = guest_included - totalGuestIncludedPerRoom
            if(remainingGuest[guest] > guest_included){
              includedGuest[guest] = remainingPaxPerRoom
              remainingGuest[guest] -= remainingPaxPerRoom
            }else{
              includedGuest[guest] = remainingPaxPerRoom > remainingGuest[guest] ? remainingGuest[guest] : remainingPaxPerRoom
              remainingGuest[guest] -= includedGuest[guest]
            }
          }
        });
        return { includedGuest, remainingGuest }
      },
      allocateSpecificGuestPerRoom(remainingGuests, maxGuests, includedGuests){
        let allocatedGuests = { adult: 0, child: 0, infant: 0 };
        let remainingIncluded = includedGuests;

        const allocate = (type) => {
          if (remainingIncluded <= 0) return;
          const count = Math.min(remainingGuests[type], maxGuests[type], remainingIncluded);
          allocatedGuests[type] = count;
          remainingGuests[type] -= count;
          remainingIncluded -= count;
        }

        allocate('adult');
        allocate('child');
        allocate('infant');

        return allocatedGuests;
      },
      generateRoomRateGuestParam(selectedRoomRateQty, currentRoomRate){
        let finalCountGuests = []
        
        const { rate, room_type } = currentRoomRate
        const {
          use_max_guest_by_pax = false,
          max_guests = null,
          max_guest_adult = 0,
          max_guest_children = 0,
          max_guest_infant = 0,
        } = rate.max_guests ? rate : room_type;
        const roomConfig = {use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant}

        const GUEST_TYPE = ['adult','child','infant'];
        let remainingGuestFilter = this.generateRemainingGuestFilter()
        const totalRemainingGuestFilter = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

        for (let i = 0; i < selectedRoomRateQty; i++) {
          let guestParams = {
            included: { adult: 0, child: 0, infant: 0 },
            extra: { adult: 0, child: 0, infant: 0 },
          }
          
          if(totalRemainingGuestFilter === 0){
            guestParams.included = this.includeGuestParamsIfZeroTotal(rate.guest_included, roomConfig)
            finalCountGuests.push(guestParams);
          }else{
            
            // Calculate guest included
            if(use_max_guest_by_pax){
              const maxGuests = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
              guestParams.included = this.allocateSpecificGuestPerRoom(remainingGuestFilter, maxGuests, rate.guest_included);
            }else{
              if(totalRemainingGuestFilter > rate.guest_included){
                const { includedGuest, remainingGuest } = this.allocateGuestPerRoom(guestParams.included, remainingGuestFilter, rate.guest_included)
                guestParams.included = includedGuest
                remainingGuestFilter = remainingGuest
              }else{
                guestParams.included = remainingGuestFilter
                remainingGuestFilter = { adult: 0, child: 0, infant: 0 }
              }
            }

            finalCountGuests.push(guestParams);

            // Calculate extra guest
            const isLastLooper = i+1 === selectedRoomRateQty;
            if(isLastLooper){
              let notIncludedGuest = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

              if(notIncludedGuest > 0){
                for(let j = 0; j < selectedRoomRateQty; j++){
                  let guestPerQtyRoom = finalCountGuests[j]
                  if(use_max_guest_by_pax){
                    const maxGuestsPerType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
                    const guestIncluded = guestPerQtyRoom.included
                    
                    for (const type of GUEST_TYPE){
                      let remainingPaxForExtra = maxGuestsPerType[type] - guestIncluded[type];
                      if(remainingPaxForExtra <= 0) continue;

                      const totalCurrentGuest = Object.values(finalCountGuests[j]).flatMap(Object.values).reduce((a, b) => a + b, 0);
                      if(max_guests <= totalCurrentGuest) continue;

                      const remainingFromMaxGuests = max_guests - totalCurrentGuest;
                      const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type], remainingFromMaxGuests);
                      finalCountGuests[j].extra[type] = extraFinal;
                      remainingGuestFilter[type] -= extraFinal;
                    }

                  }else{
                    let totalGuestIncludedPerRoom = Object.values(guestPerQtyRoom.included).reduce((sum, value) => sum + value, 0);  
                    let remainingPaxForExtra = max_guests-totalGuestIncludedPerRoom

                    for (const type of GUEST_TYPE) {
                      if (remainingGuestFilter[type] > 0) {
                        const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type]);
                        finalCountGuests[j].extra[type] = extraFinal;
                        remainingGuestFilter[type] -= extraFinal;
                      }
                      
                    }
                  }
                }
              }
            }
          }
        }

        return finalCountGuests;
      },
      addRoomRate(qty, selectedRoomRate){
        const validQty = parseInt(qty);
        const currentRoomRate = this.$deepCopy(selectedRoomRate)
        
        const savedRoom = this.$deepCopy(this.getBeCartRoom())
        let savedRoomRateIndex = savedRoom.findIndex(savedRoomRate=>savedRoomRate.room_rate.id === currentRoomRate.id)
        
        if(savedRoomRateIndex != -1){
          this.beRemoveRoomRate(currentRoomRate.id);
          this.updateRoomTypeAvailability(savedRoom[savedRoomRateIndex].qty, currentRoomRate, 'inc')
          setTimeout(()=>{
            this.addRoomRate(validQty, currentRoomRate)
          },100)
        } else {
          this.updateRoomTypeAvailability(validQty, currentRoomRate, 'dec')
          const roomRateParam = {
            room_rate: currentRoomRate,
            qty: validQty,
            guest: this.generateRoomRateGuestParam(validQty, currentRoomRate)
          }
          this.BeManipulateRoomRate(roomRateParam)
          setTimeout(()=>{
            this.close()
          },100)
        }
      },
      isToggle(type,data){
        if (type == 'policy') {
          this.more_policy = data
        }else if(type == 'inclusions') {
          this.more_inclusions = data
        }
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/roomRateDetail.vue